import { ROLES, checkPermissionExistence, userPermission } from "./index";

const onlyClubHeadCoach = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[2];
};

const exceptClubHeadCoach = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[2]);
  return roles.includes(userPermission());
};

const onlyPremiumClubHeadCoach = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[3];
};

const exceptPremiumClubHeadCoach = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[3]);
  return roles.includes(userPermission());
};

const onlyClubCoach = () => {
  return onlyClubHeadCoach() || onlyPremiumClubHeadCoach();
};

const exceptClubCoach = () => {
  return exceptClubHeadCoach() && exceptPremiumClubHeadCoach();
};

export default {
  onlyClubHeadCoach,
  exceptClubHeadCoach,
  onlyPremiumClubHeadCoach,
  exceptPremiumClubHeadCoach,
  onlyClubCoach,
  exceptClubCoach
};
